import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';
import { callsToAction } from '../../data/practice';
export default function HeroSection() {
  return <section className="bg-gradient-to-br from-primary via-primary-dark to-primary text-white py-20 md:py-24 lg:py-32 pt-24 md:pt-28" data-id="element-209" data-mp="21aclbkehqdqh">
      <div className="container mx-auto px-4" data-id="element-210" data-mp="1x7pqrbqfqepl">
        <div className="flex flex-col items-center text-center" data-id="element-211" data-mp="1xb3schr9yjvz">
          <motion.div className="max-w-3xl w-full" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-212" data-mp="1sag1bw31q31r">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-213" data-mp="1dml8mfp1fyoo">
              <span className="block mb-2" data-id="element-214" data-mp="19kzqaetqis73">Medico-Legal Psychiatry</span>
              <span className="block text-2xl md:text-3xl lg:text-4xl text-secondary" data-id="element-215" data-mp="14klr7ma42sl7">
                Expert Witness Psychiatric Services UK
              </span>
            </h1>
            <p className="text-lg md:text-xl mb-8 leading-relaxed opacity-90" data-id="element-216" data-mp="36fw59q33qvqm">
              Independent psychiatric assessments and expert witness reports
              by Dr Imtiaz Syed for solicitors, barristers, case managers and
              courts. Remote and face-to-face assessments across England and
              Wales.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-217" data-mp="3kcsx9uuyij93">
              <Button variant="secondary" size="lg" href={callsToAction.discussInstruction.href} pulse data-id="element-218" data-mp="3pcxdrkvv7dzb">
                {callsToAction.discussInstruction.label}
              </Button>
              <Button variant="transparent" size="lg" href={callsToAction.requestFeeQuote.href} data-id="element-219" data-mp="1zyiqz64eq16g">
                {callsToAction.requestFeeQuote.label}
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}